








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { PaymentMethodDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxPaymentMethod extends Vue {
  private types: PaymentMethodDto[] | null = [];
  public selectedType = new PaymentMethodDto();

  public created() {
    this.getAvailableTypes();
  }

  public typeSelected(type: PaymentMethodDto) {
    this.$emit("paymentMethodSelected", type);
  }

  public setSelected(type: PaymentMethodDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .paymentMethod_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
